import { OnInit } from '@angular/core';
var TranslatorOrientationComponent = /** @class */ (function () {
    function TranslatorOrientationComponent() {
    }
    TranslatorOrientationComponent.prototype.ngOnInit = function () {
    };
    return TranslatorOrientationComponent;
}());
export { TranslatorOrientationComponent };
